import { addMessages } from '@hana/i18n';

// Chuỗi giao diện Tiện ích. Mã phí, mã tiền tệ, tên tệp, tên riêng và dữ liệu mẫu không dịch.
addMessages('vi', {
  'ut.up': 'Đưa lên: {n}',
  'ut.down': 'Đưa xuống: {n}',
  'ut.rmFile': 'Bỏ tệp: {n}',
  'ut.removed': 'Đã bỏ {n}',
  'ut.stRead': 'Đọc tệp',
  'ut.stOcr': 'Nhận dạng',
  'ut.stDone': 'Xong',
  'ut.ocrJust': 'OCR · vừa xong',
  'ut.exported': 'Đã xuất {n}',
  'ut.shAdded': 'Đã thêm shipper {k} từ job {j}',
  'ut.rmShip': 'Bỏ shipper {i}',
  'ut.shRemoved': 'Đã bỏ shipper {n}',
  'ut.shName': 'Tên shipper {i}',
  'ut.feeCodeRow': 'Mã phí dòng {i}',
  'ut.feeAmt': 'Số tiền dòng {i}',
  'ut.feeCur': 'Tiền tệ dòng {i}',
  'ut.rmRow': 'Bỏ dòng {i}',
  'ut.noQuote': 'Vietcombank không niêm yết cặp này cho ngày đã chọn.',
  'ut.sellRate': 'giá bán',
  'ut.buyTt': 'giá mua chuyển khoản',
  'ut.shipper': 'Shipper {i}',
  'ut.m365Sub': 'Giữ định dạng gốc tốt nhất · cần mạng',
  'ut.local': 'Trong máy',
  'ut.localSub': 'Chạy khi Microsoft 365 lỗi · định dạng đơn giản hơn',
  'ut.unitProp': 'Unit · chia tỉ lệ',
  'ut.unitShpt': 'Shpt · mỗi shipper',
  'ut.merge': 'Tệp cần ghép',
  'ut.drop': 'Kéo thả hoặc chọn tệp',
  'ut.dropTypes': 'PDF, ảnh (JPG, PNG), Word, Excel, text',
  'ut.options': 'Tuỳ chọn',
  'ut.mergedName': 'Tên tệp ghép',
  'ut.a4': 'Đưa ảnh về khổ A4, giữ tỉ lệ',
  'ut.bookmark': 'Đánh dấu trang theo tên tệp',
  'ut.src': 'Tệp gốc',
  'ut.pick': 'Chọn tệp',
  'ut.dropOcr': 'Kéo thả ảnh chụp, PDF scan, Word, Excel',
  'ut.ocrSub': 'Ask HANA đọc chữ và bảng',
  'ut.result': 'Kết quả',
  'ut.exportAs': 'Xuất ra',
  'ut.noOcr': 'Chưa trích chữ',
  'ut.wordExcel': 'Tệp Word / Excel',
  'ut.addFile': '+ Thêm tệp',
  'ut.way': 'Cách chuyển',
  'ut.splitDate': 'Ngày chia',
  'ut.rate': 'Tỷ giá USD → ₫',
  'ut.getVcb': 'Lấy giá bán VCB',
  'ut.basis': 'Cơ sở chia dòng ĐVT Unit',
  'ut.addFromJob': 'Thêm shipper từ job',
  'ut.noJob': 'Không có job LCL khớp.',
  'ut.fees': 'Phí cần chia',
  'ut.addFee': 'Thêm phí',
  'ut.feeCode': 'Mã phí',
  'ut.amount': 'Số tiền',
  'ut.cur': 'Tiền tệ',
  'ut.unit': 'ĐVT',
  'ut.vnd': 'Quy đổi ₫',
  'ut.splitRes': 'Kết quả chia (₫)',
  'ut.fee': 'Phí',
  'ut.total': 'Tổng',
  'ut.totalEach': 'Tổng mỗi shipper',
  'ut.xlsx': 'Xuất Excel',
  'ut.convertH': 'Quy đổi',
  'ut.from': 'Từ',
  'ut.to': 'Sang',
  'ut.rateType': 'Loại giá',
  'ut.date': 'Ngày',
  'ut.vcbTable': 'Bảng tỷ giá Vietcombank',
  'ut.code': 'Mã',
  'ut.name': 'Tên',
  'ut.buyCash': 'Mua tiền mặt',
  'ut.buyTransfer': 'Mua chuyển khoản',
  'ut.sell': 'Bán',
  'ut.madeToday': 'Tệp đã tạo hôm nay',
  'ut.download': 'Tải',
  'ut.attach': 'Gắn vào job',
  'ut.noMade': 'Chưa có tệp nào hôm nay.',
  'ut.retry': 'Thử lại',
  'ut.reqPerm': 'Gửi yêu cầu cấp quyền',
  'ut.view': 'Xem',
  'ut.noMerge': 'Chưa có tệp nào. Thêm ít nhất 2 tệp để ghép.',
  'ut.ocrHint': 'Chọn tệp rồi bấm “Trích chữ”. Bảng trong tệp được giữ thành bảng khi xuất Excel.',
  'ut.noConv': 'Chưa có tệp. Thêm .docx, .xlsx, .xls, .doc để chuyển sang PDF.',
  'ut.noShip': 'Chưa có shipper — tìm job LCL ở trên hoặc bấm “+ Shipper”.',
  'ut.pdfNote': 'PDF vector, có ký tên người lập: DAVID · Sales Manager · dùng để báo phí cho từng shipper.',
  'ut.errTail': 'Đang dùng bảng 21/Oct/2026 16:00. Chuyển Office qua Microsoft 365 tạm lỗi — dùng cách chuyển trong máy.',
  'ut.errHead': 'Không lấy được tỷ giá Vietcombank lúc 09:02.',
  'ut.mfCount': '{n} tệp · {p} trang',
  'ut.pgSize': '{p} trang · {z}',
  'ut.ocrMeta': '1 trang · 1,8 MB · ảnh chụp',
  'ut.converted': 'Đã chuyển',
  'ut.pending': 'Chờ chuyển',
  'ut.fromJob': 'từ job',
  'ut.wayTip': 'Excel giữ viền, ô gộp, độ rộng cột của bản gốc. Mỗi sheet thành một nhóm trang.',
  'ut.madeTip': 'Tệp tạo bằng tiện ích giữ 7 ngày trong máy. Gắn vào job để lưu vào chứng từ.',
  'ut.mergeTip': 'Word / Excel được chuyển sang PDF trước khi ghép. Tệp không đọc được sẽ bị bỏ qua và báo tên.',
  'ut.dense0': 'Chuẩn',
  'ut.dense1': 'Gọn',
  'ut.densAria': 'Mật độ hiển thị',
  'ut.title': 'Tiện ích',
  'ut.bellAria': 'Thông báo, 4 chưa đọc',
  'ut.bell': 'Thông báo',
  'ut.madeAria': 'Tệp đã tạo',
  'ut.noPerm': 'Chưa có quyền',
  'ut.soon': '{m} — chưa mở ở bản này',
  'ut.noWrite': 'Chưa mở ghi ở bản này',
  'ut.reqSent': 'Đã gửi yêu cầu cấp quyền cho Admin',
  'ut.permDesc': 'Chưa có quyền dùng tiện ích này. Ghép file, chia phí và tỷ giá vẫn dùng bình thường.',
  'ut.permTitle': 'Chưa có quyền dùng {w}',
  'ut.wOcr': 'OCR & trích chữ',
  'ut.wConv': 'chuyển Word / Excel → PDF',
  'ut.mergeOpt': 'Tuỳ chọn ghép',
  'ut.ocrRes': 'Kết quả trích chữ',
  'ut.office': 'Tệp Office',
  'ut.splitAria': 'Chia phí consol theo shipper',
  'ut.pickMerge': 'Chọn tệp cần ghép',
  'ut.pickOcr': 'Chọn tệp để trích chữ',
  'ut.ocrText': 'Chữ trích được',
  'ut.pickOffice': 'Chọn tệp Word hoặc Excel',
  'ut.basisAria': 'Cơ sở chia',
  'ut.lclJob': 'Job LCL',
  'ut.swapAria': 'Đổi chiều quy đổi',
  'ut.jobSearch': 'Tìm job theo JobID, khách, booking, HBL',
  'ut.jobPh': 'JobID, khách, booking, HBL…',
  'ut.swap': 'Đổi chiều',
  'ut.vnd2': 'Đồng Việt Nam',
  'ut.priMerge': 'Ghép thành PDF',
  'ut.priOcr': 'Trích chữ',
  'ut.priConv': 'Chuyển sang PDF',
  'ut.priPdf': 'Xuất PDF',
});

addMessages('en', {
  'ut.up': 'Move up: {n}',
  'ut.down': 'Move down: {n}',
  'ut.rmFile': 'Remove file: {n}',
  'ut.removed': 'Removed {n}',
  'ut.stRead': 'Read file',
  'ut.stOcr': 'Recognise',
  'ut.stDone': 'Done',
  'ut.ocrJust': 'OCR · just now',
  'ut.exported': 'Exported {n}',
  'ut.shAdded': 'Added shipper {k} from job {j}',
  'ut.rmShip': 'Remove shipper {i}',
  'ut.shRemoved': 'Removed shipper {n}',
  'ut.shName': 'Shipper {i} name',
  'ut.feeCodeRow': 'Fee code, row {i}',
  'ut.feeAmt': 'Amount, row {i}',
  'ut.feeCur': 'Currency, row {i}',
  'ut.rmRow': 'Remove row {i}',
  'ut.noQuote': 'Vietcombank does not quote this pair for the selected date.',
  'ut.sellRate': 'selling rate',
  'ut.buyTt': 'buying rate (transfer)',
  'ut.shipper': 'Shipper {i}',
  'ut.m365Sub': 'Best original formatting · needs network',
  'ut.local': 'On device',
  'ut.localSub': 'Used when Microsoft 365 fails · simpler formatting',
  'ut.unitProp': 'Unit · pro rata',
  'ut.unitShpt': 'Shpt · per shipper',
  'ut.merge': 'Files to merge',
  'ut.drop': 'Drag and drop or choose files',
  'ut.dropTypes': 'PDF, images (JPG, PNG), Word, Excel, text',
  'ut.options': 'Options',
  'ut.mergedName': 'Merged file name',
  'ut.a4': 'Fit images to A4, keep aspect ratio',
  'ut.bookmark': 'Bookmark pages by file name',
  'ut.src': 'Source file',
  'ut.pick': 'Choose file',
  'ut.dropOcr': 'Drag and drop photos, scanned PDFs, Word, Excel',
  'ut.ocrSub': 'Ask HANA reads text and tables',
  'ut.result': 'Result',
  'ut.exportAs': 'Export as',
  'ut.noOcr': 'Text not extracted yet',
  'ut.wordExcel': 'Word / Excel files',
  'ut.addFile': '+ Add file',
  'ut.way': 'Conversion method',
  'ut.splitDate': 'Split date',
  'ut.rate': 'USD → ₫ rate',
  'ut.getVcb': 'Get VCB sell rate',
  'ut.basis': 'Basis for Unit lines',
  'ut.addFromJob': 'Add shipper from job',
  'ut.noJob': 'No matching LCL job.',
  'ut.fees': 'Fees to split',
  'ut.addFee': 'Add fee',
  'ut.feeCode': 'Fee code',
  'ut.amount': 'Amount',
  'ut.cur': 'Currency',
  'ut.unit': 'UoM',
  'ut.vnd': 'Converted ₫',
  'ut.splitRes': 'Split result (₫)',
  'ut.fee': 'Fee',
  'ut.total': 'Total',
  'ut.totalEach': 'Total per shipper',
  'ut.xlsx': 'Export Excel',
  'ut.convertH': 'Convert',
  'ut.from': 'From',
  'ut.to': 'To',
  'ut.rateType': 'Rate type',
  'ut.date': 'Date',
  'ut.vcbTable': 'Vietcombank rate table',
  'ut.code': 'Code',
  'ut.name': 'Name',
  'ut.buyCash': 'Cash buy',
  'ut.buyTransfer': 'Transfer buy',
  'ut.sell': 'Sell',
  'ut.madeToday': 'Files created today',
  'ut.download': 'Download',
  'ut.attach': 'Attach to job',
  'ut.noMade': 'No files created today.',
  'ut.retry': 'Retry',
  'ut.reqPerm': 'Request access',
  'ut.view': 'View',
  'ut.noMerge': 'No files yet. Add at least 2 files to merge.',
  'ut.ocrHint': 'Choose a file then press “Extract text”. Tables in the file stay tables when exported to Excel.',
  'ut.noConv': 'No files yet. Add .docx, .xlsx, .xls, .doc to convert to PDF.',
  'ut.noShip': 'No shippers yet — find an LCL job above or press “+ Shipper”.',
  'ut.pdfNote': 'Vector PDF, signed by the preparer: DAVID · Sales Manager · used to quote fees to each shipper.',
  'ut.errTail': 'Using the 21/Oct/2026 16:00 table. Office conversion via Microsoft 365 is temporarily down — use the local method.',
  'ut.errHead': 'Could not get the Vietcombank rate at 09:02.',
  'ut.mfCount': '{n} files · {p} pages',
  'ut.pgSize': '{p} pages · {z}',
  'ut.ocrMeta': '1 page · 1.8 MB · photo',
  'ut.converted': 'Converted',
  'ut.pending': 'Pending',
  'ut.fromJob': 'from job',
  'ut.wayTip': 'Excel keeps borders, merged cells and column widths of the original. Each sheet becomes a group of pages.',
  'ut.madeTip': 'Files made with the utility are kept 7 days on this device. Attach to a job to save into documents.',
  'ut.mergeTip': 'Word / Excel are converted to PDF before merging. Unreadable files are skipped and named.',
  'ut.dense0': 'Standard',
  'ut.dense1': 'Compact',
  'ut.densAria': 'Display density',
  'ut.title': 'Utilities',
  'ut.bellAria': 'Notifications, 4 unread',
  'ut.bell': 'Notifications',
  'ut.madeAria': 'Created files',
  'ut.noPerm': 'No permission',
  'ut.soon': '{m} — not available in this version yet',
  'ut.noWrite': 'Writing is not available in this version yet',
  'ut.reqSent': 'Access request sent to Admin',
  'ut.permDesc': 'No permission to use this utility. Merging, fee splitting and exchange rates still work normally.',
  'ut.permTitle': 'No permission to use {w}',
  'ut.wOcr': 'OCR & text extraction',
  'ut.wConv': 'Word / Excel → PDF conversion',
  'ut.mergeOpt': 'Merge options',
  'ut.ocrRes': 'Text extraction result',
  'ut.office': 'Office files',
  'ut.splitAria': 'Split consol fees by shipper',
  'ut.pickMerge': 'Choose files to merge',
  'ut.pickOcr': 'Choose file to extract text',
  'ut.ocrText': 'Extracted text',
  'ut.pickOffice': 'Choose Word or Excel file',
  'ut.basisAria': 'Split basis',
  'ut.lclJob': 'LCL jobs',
  'ut.swapAria': 'Swap conversion direction',
  'ut.jobSearch': 'Search jobs by JobID, customer, booking, HBL',
  'ut.jobPh': 'JobID, customer, booking, HBL…',
  'ut.swap': 'Swap',
  'ut.vnd2': 'Vietnamese dong',
  'ut.priMerge': 'Merge into PDF',
  'ut.priOcr': 'Extract text',
  'ut.priConv': 'Convert to PDF',
  'ut.priPdf': 'Export PDF',
});

